import { createSlice } from '@reduxjs/toolkit'
import { API } from 'src/utils/interceptor'
import Sentry from 'src/utils/sentry'

const initialState = {
  manualProducts: [],
  isLoading: false,
  error: null,
}

const manualSuppliersProductsSlice = createSlice({
  name: 'manualSuppliersProducts',
  initialState,
  reducers: {
    setManualProducts: (state, action) => {
      state.manualProducts = action.payload
    },
    addManualProduct: (state, action) => {
      state.manualProducts.push(action.payload)
    },
    deleteManualProduct: (state, action) => {
      state.manualProducts = state.manualProducts.filter(
        item => item._id !== action.payload,
      )
    },
    editManualProduct: (state, action) => {
      const index = state.manualProducts.findIndex(
        product => product._id === action.payload._id,
      )
      if (index !== -1) state.manualProducts[index] = action.payload
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    resetManualProducts: state => {
      state = initialState
      return state
    },
  },
})

export const {
  setManualProducts,
  addManualProduct,
  deleteManualProduct,
  editManualProduct,
  setIsLoading,
  setError,
  resetManualProducts,
} = manualSuppliersProductsSlice.actions

export const fetchManualSuppliersProducts = venueId => async dispatch => {
  try {
    dispatch(setIsLoading(true))
    dispatch(setError(null))
    const data = await API.get('api2', `venue/${venueId}/products`)
    dispatch(setManualProducts(data))
    dispatch(setIsLoading(false))
  } catch (e) {
    console.error('Error fetching manual suppliers products:', e)
    dispatch(setIsLoading(false))
    dispatch(setError(e.message))
    Sentry.captureException(e)
    return false
  }
}

export default manualSuppliersProductsSlice
